import {IController, IFormController, IModule, IOnChangesObject} from "angular";
import {Debugger} from "debug";
import {l} from "../../../../../types/typescriptdefinisjoner_lederplan";
import {dersomChangesInneholder} from "../../../../../felles/stoettefunk/angularHjelpemetoder";

const debug: Debugger = require('debug')('MøtemalDetaljerSkjemaKontroller');
const css = require('./nyttMøtePubliseringSkjema.scss');

export class NyttMøtePubliseringSkjemaKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular.component('wmNyttMoetePubliseringSkjema', {
            bindings: {
                spesifikasjon: '<',
                gruppe: '<',
                skjema: '<'
            },
            controller: NyttMøtePubliseringSkjemaKontroller.forInjisering(),
            template: require('./nyttMøtePubliseringSkjema.html')
        });
    }

    static forInjisering() {
        return [
            NyttMøtePubliseringSkjemaKontroller
        ]
    }

    constructor() {
    }

    spesifikasjon: PubliseringSpesifikasjon; //settes via bindings
    gruppe: l.GruppeModell; //settes via bindings
    skjema: IFormController; //settes via bindings©

    medlemmerMedTilgangIkkePublisert:string;

    $onChanges(endringer: IOnChangesObject): void {
        dersomChangesInneholder(endringer, 'gruppe', avstemning => this.initMedlemmerMedTilgangIkkePublisert());
    }

    //hjelpemetoder

    private initMedlemmerMedTilgangIkkePublisert(){
        this.medlemmerMedTilgangIkkePublisert = this.gruppe?.medlemmer
            .filter(medlem => medlem.tilgangsroller.some(rolle => rolle == l.TilgangsrolleMedlem.tilgangIkkePublisert || rolle == l.TilgangsrolleMedlem.skrive))
            .map(medlem => medlem.navn)
            .join(', ')
    }
}

export interface PubliseringSpesifikasjon {
    erMoetePublisert: boolean;
    erProtokollPublisert: boolean;
}
